import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const availabilityRegion = {
  namespaced: true,
  state: {
    user: '',
    center: ""
  },
  getters,
  mutations,
  actions
}
